<template>
  <footer>
    <div class="socials">
      <a href="#">
        <FacebookIcon/>
      </a>
      <a href="https://www.instagram.com/american.holocaust/" target="_blank">
        <InstagramIcon/>
      </a>
      <a href="#">
        <TwitterIcon/>
      </a>
    </div>
  </footer>
</template>

<script>
import FacebookIcon from './icons/Facebook.vue'
import InstagramIcon from './icons/Instagram.vue'
import TwitterIcon from './icons/Twitter.vue'

export default {
  name: 'Footer',
  components: {
    FacebookIcon,
    InstagramIcon,
    TwitterIcon,
  },
}
</script>

<style lang="scss" scoped>
footer {
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 8px;

  .socials {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 128px;
    align-self: center;
    width: 100%;

    a {
      svg {
        width: 24px;
        height: 24px;
        border: 2px solid #1b305f;
        border: 2px solid #2c3e50;
        padding: 2px;
        border-radius: 50%;
        margin-right: 0;
        fill: #1b305f;
        fill: #2c3e50;
      }

      &:focus {
        outline: none;
      }
    }
  }
}
</style>
